export const toCamelCase = (string, ucfirst) => {
  ucfirst = typeof ucfirst === 'undefined' ? false : ucfirst;

  const stringSections = string.split('.');
  let result = '';

  for (let n = 0; n < stringSections.length; n++) {
    result +=
      stringSections[n].charAt(0).toUpperCase() + stringSections[n].slice(1);
  }

  if (ucfirst !== true) {
    result = result.charAt(0).toLowerCase() + result.slice(1);
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/helpers/toCamelCase.js